import { render, staticRenderFns } from "./pageCustomDialog.vue?vue&type=template&id=4c30d3da&scoped=true&"
import script from "./pageCustomDialog.vue?vue&type=script&lang=ts&"
export * from "./pageCustomDialog.vue?vue&type=script&lang=ts&"
import style0 from "./pageCustomDialog.vue?vue&type=style&index=0&id=4c30d3da&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c30d3da",
  null
  
)

export default component.exports